import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const rows: {
  before: string;
  after: string;
}[] = [{
  before: '“Just act natural” — and they freeze',
  after: '“Start from the bottom. Every few, look up at her.” — direction that produces the candid frame'
}, {
  before: 'Family formals: 50 minutes of herding cats in heels',
  after: '12 minutes. Called by name, smallest to largest, done before cocktail hour is'
}, {
  before: 'Your mind goes blank after five poses',
  after: 'A progression — standing → movement → intimate — that runs as long as the light does'
}, {
  before: '45 minutes behind and no idea what to cut',
  after: 'Break Points: you know exactly what to cut first, and what you never cut'
}, {
  before: 'Sneaking looks at your phone for prompts',
  after: 'A printed one-page run sheet clipped to your bag. Phone in your pocket.'
}, {
  before: 'The photographer who waits for something to happen',
  after: 'The director who makes it happen — the calmest person in the room'
}];
export function Transformation() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-339" data-mp="1765r2m7kxyl9">
      <div className="mx-auto max-w-5xl px-5" data-id="element-340" data-mp="135283qu8jmft">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-341" data-mp="135vid1seku2p">
          From winging it to directing the day
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-342" data-mp="1uwi4gcllgnj8" />

        <div className="mt-12 overflow-hidden border border-gold-soft" data-id="element-343" data-mp="1uvqcdbr7h7xp">
          <div className="grid grid-cols-2" data-id="element-344" data-mp="1qw7oq8802ir6">
            <div className="flex items-center gap-2 border-b border-r border-gold-soft bg-blush-soft px-4 py-3.5 text-[10px] uppercase tracking-[0.16em] text-blush-deep sm:px-6 sm:py-4 sm:text-[11px] sm:tracking-[0.2em]" data-id="element-345" data-mp="1m47u8vap8i1z">
              <XIcon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-346" data-mp="2el0pqj3hbgsn" />
              Before
            </div>
            <div className="flex items-center gap-2 border-b border-gold-soft bg-gold-tint px-4 py-3.5 text-[10px] uppercase tracking-[0.16em] text-gold-dark sm:px-6 sm:py-4 sm:text-[11px] sm:tracking-[0.2em]" data-id="element-347" data-mp="29til9l28yy2x">
              <CheckIcon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-348" data-mp="2xo2hwpvu7gos" />
              With Direct the Day
            </div>
          </div>

          {rows.map((row, index) => <div key={row.after} className={`grid grid-cols-2 ${index > 0 ? 'border-t border-gold-soft/70' : ''}`} data-id="element-349" data-mp="2nyixvgwe1gsc" data-mpi={index}>
              <p className="border-r border-gold-soft/70 bg-ivory px-4 py-4 text-[13px] leading-relaxed text-ink-soft sm:px-6 sm:py-5 sm:text-[15px]" data-id="element-350" data-mp="2ez5m2hkskg4g">
                {row.before}
              </p>
              <p className="bg-white px-4 py-4 text-[13px] font-medium leading-relaxed text-ink sm:px-6 sm:py-5 sm:text-[15px]" data-id="element-351" data-mp="24zwvzzt1rlnd">
                {row.after}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}